import { render, staticRenderFns } from "./ModalFormularioProgramaUniversidad.vue?vue&type=template&id=a3010bfa&scoped=true"
import script from "./ModalFormularioProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioProgramaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioProgramaUniversidad.vue?vue&type=style&index=0&id=a3010bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3010bfa",
  null
  
)

export default component.exports